export default function Testimonial() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row-reverse items-stretch gap-0">
          <div className="w-full lg:w-[58%] bg-foreground-900 rounded-3xl p-8 md:p-14 relative overflow-hidden -mt-6 lg:-mt-0 lg:-ml-12 z-10">
            <div className="absolute top-8 left-8 text-7xl md:text-8xl font-heading text-accent-400/20 leading-none select-none">
              &ldquo;
            </div>

            <div className="relative z-10 pt-10 md:pt-14">
              <p className="text-background-50/90 text-base md:text-lg leading-relaxed max-w-lg">
                I have been sourcing products for over three years, and discovering the
                <strong className="text-background-50"> acbuyspreadsheet </strong>
                system completely changed my workflow. The acbuy spreadsheet listings are always
                up to date, the category filtering saves me at least two hours every day, and
                the supplier verification data gives me confidence before placing any order.
                If you are serious about product sourcing, this is an essential resource that
                pays for itself almost immediately.
              </p>

              <div className="mt-8">
                <p className="text-background-50 font-semibold text-sm">Alex M.</p>
                <p className="text-background-50/60 text-xs mt-0.5">Verified Buyer &amp; Sourcing Professional</p>
              </div>

              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="mt-8 inline-flex items-center gap-2 bg-accent-500 text-background-50 font-medium text-sm px-7 py-3 rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Join ACBuy Now
                <i className="ri-arrow-right-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[42%] flex items-center">
            <div className="w-full rounded-3xl overflow-hidden h-[320px] md:h-[400px]">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20young%20entrepreneur%20sitting%20at%20minimal%20home%20office%20desk%20with%20laptop%20and%20fashion%20items%2C%20warm%20golden%20hour%20window%20light%20creating%20soft%20shadows%2C%20confident%20relaxed%20expression%2C%20modern%20cream%20and%20beige%20interior%2C%20editorial%20portrait%20photography%20with%20authentic%20lifestyle%20feel&width=700&height=900&seq=testimonial-portrait-v2&orientation=portrait"
                alt="ACBuy Spreadsheet User Testimonial"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}